import { Injectable } from '@angular/core';
import { SecurityService } from '@core/services/system/security.service';
import { SERVER_CONFIG } from '@shared/constants/server.const';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SecuredResponse } from '@shared/classes/secured-response.class';

export type TwoFaCredentialsResponseData = {
  qrBase64: string,
  code: string
}


@Injectable()
export class TwoFaApiService {

  constructor(private readonly securityService: SecurityService) {}

  getRegInfo(email: string): Observable<TwoFaCredentialsResponseData> {
    const encodedEmail = encodeURIComponent((email || '').trim());
    const twoFaRegInfoUrl: string = `${SERVER_CONFIG.API_V2_URL}public/2fa/regInfo?email=${encodedEmail}`;
    return this.securityService.doSecureRequestObservable(twoFaRegInfoUrl, 'get').pipe(
      map((response: SecuredResponse): TwoFaCredentialsResponseData => {
        return response.data as TwoFaCredentialsResponseData;
      })
    );
  }

  reset2Fa(email: string, callbackUrl?: string): Observable<boolean> {
    const twoFaResetUrl: string = `${SERVER_CONFIG.API_V2_URL}public/2fa/restoreEmail`;
    const payload: { email: string; callbackUrl?: string } = { email };
    if (callbackUrl) {
      payload.callbackUrl = callbackUrl;
    }
    return this.securityService.doSecureRequestObservable(twoFaResetUrl, 'post', payload).pipe(
      map((response: SecuredResponse): boolean => {
        return !!response?.data?.success;
      })
    );
  }
}
